import React, { useState, useEffect } from "react";
import Card from "./Card";
import "../Dashboard.css";

const GoogleAdsComponent = ({ startDate, endDate, refreshTrigger, setCampaignNames, filteredCampaigns }) => {
    const [totals, setTotals] = useState({
        impressions: 0,
        clicks: 0,
        conversions: 0,
        cost: 0,
        ctr: 0,
        average_cpc: 0,
        cost_per_conversion: 0
    });
    const [campaigns, setCampaigns] = useState([]);
    const [leads, setLeads] = useState([]);
    const urlParams = new URLSearchParams(window.location.search);
    const showData = urlParams.get('keyword') || 'false';

    const adsColors = ['#176BEF', '#FF3E30', '#F7B529', '#179C52', '#8A3FFC'];

    const fetchData = async () => {
        try {
            let url = `https://api.casedb.co/google_ads.php`;
            if (startDate && endDate) {
                url += `?start_date=${startDate}&end_date=${endDate}`;
            }
    
            const response = await fetch(url);
            const result = await response.json();
    
            if (result.success) {
                const totalImpressions = result.data.reduce((sum, item) => sum + item.impressions, 0);
                const totalClicks = result.data.reduce((sum, item) => sum + item.clicks, 0);
                const totalConversions = result.data.reduce((sum, item) => sum + item.conversions, 0);
                const totalCost = result.data.reduce((sum, item) => sum + parseFloat(item.cost_usd.replace(/,/g, '')), 0);
                const totalCtr = totalImpressions > 0 ? totalClicks / totalImpressions : 0;
                const totalAverageCpc = totalClicks > 0 ? totalCost / totalClicks : 0;
                const totalCostPerConversion = totalConversions > 0 ? totalCost / totalConversions : 0;
    
                const keywordMap = {};
    
                result.data.forEach(campaign => {
                    if (campaign.top_keywords) {
                        campaign.top_keywords.forEach(keyword => {
                            const text = keyword.keyword_text;
                            if (!keywordMap[text]) {
                                keywordMap[text] = {
                                    ...keyword,
                                    total_conversions: keyword.conversions,
                                };
                            } else {
                                keywordMap[text].total_conversions += keyword.conversions;
                            }
                        });
                    }
                });

                const topKeywordsArray = Object.values(keywordMap)
                    .sort((a, b) => b.total_conversions - a.total_conversions)
                    .slice(0, 10);
    
                setTotals({
                    impressions: totalImpressions,
                    clicks: totalClicks,
                    conversions: totalConversions,
                    cost: totalCost,
                    ctr: totalCtr,
                    average_cpc: totalAverageCpc,
                    cost_per_conversion: totalCostPerConversion,
                    top_keywords: topKeywordsArray,
                });
    
                setCampaigns(result.data.filter(campaign => campaign.impressions > 0));
                setLeads(result.leads || []);
            } else {
                console.error("Error:", result.error);
            }
        } catch (error) {
            console.error("Fetch Error:", error);
        }
    };    

    useEffect(() => {
        if (refreshTrigger > 0) fetchData();
    }, [refreshTrigger]);

    useEffect(() => {
        const uniqueCampaignNames = [...new Set(campaigns.map(campaign => campaign.campaign_name))];
        setCampaignNames(uniqueCampaignNames);
    }, [campaigns, setCampaignNames]);

    return (
        <>
            <div className='google-overview'>
                <Card data={{ title: "Total Impressions - Google Ads", data: totals.impressions.toLocaleString() }} />
                <Card data={{ title: "Total Clicks - Google Ads", data: totals.clicks.toLocaleString() }} />
                <Card data={{ title: "Total Conversions - Google Ads", data: [totals.conversions.toFixed(0).toLocaleString(), `${totals.cost_per_conversion > 0 ? `$${totals.cost_per_conversion.toFixed(2)}` : '$0.00'}/conv`] }} />
                <Card data={{ title: "Total Cost - Google Ads", data: `$${totals.cost.toLocaleString()}` }} />
                <Card data={{ title: "Average CTR - Google Ads", data: `${(totals.ctr * 100).toFixed(2)}%` }} />
                <Card data={{ title: "Average CPC - Google Ads", data: `$${totals.average_cpc.toFixed(2)}` }} />
            </div>
            {/*<Card 
                data={{ 
                    title: "Top 10 Keywords (All Campaigns) - Google Ads",
                    data: {keywords: totals.top_keywords},
                    col:4,
                    row:2
                }}
                type="list"
            />*/}
            <div className="google-keywords">
                <div className='google-keywords-header'>
                    <div className='google-keywords-title'>Top 10 Keywords</div>
                    <div className='google-keywords-actions'>

                    </div>
                </div>
                <table className='google-keywords-table'>
                    <thead>
                        <tr>
                            <th style={{ width: '25%' }}><span>Keyword (Ad Group)</span></th>
                            <th style={{ width: '15%' }}><span>Impressions</span></th>
                            <th style={{ width: '15%' }}><span>Clicks</span></th>
                            <th style={{ width: '15%' }}><span>Conversions</span></th>
                            <th style={{ width: '15%' }}><span>Cost (CPC)</span></th>
                            <th style={{ width: '15%' }}><span>CTR</span></th>
                        </tr>
                    </thead>
                    <tbody className='small-text'>
                        {totals?.top_keywords?.map((keyword, index) => (
                            <tr key={index}>
                                <td style={{ width: '25%' }}><span>{keyword.keyword_text} ({keyword.ad_group_name})</span></td>
                                <td style={{ width: '15%' }}><span>{keyword.impressions.toLocaleString()}</span></td>
                                <td style={{ width: '15%' }}><span>{keyword.clicks.toLocaleString()}</span></td>
                                <td style={{ width: '15%' }}><span>{keyword.conversions.toFixed(0).toLocaleString()} ({keyword.conversions > 0 ? `$${(parseFloat(keyword.cost_usd.replace(/,/g, '')) / keyword.conversions).toFixed(2)}` : '$0.00'}/conv)</span></td>
                                <td style={{ width: '15%' }}><span>${keyword.cost_usd.toLocaleString()} (${(parseFloat(keyword.cost_usd.replace(/,/g, '')) / keyword.clicks).toFixed(2)})</span></td>
                                <td style={{ width: '15%' }}><span>{(keyword.clicks / keyword.impressions * 100).toFixed(2)}%</span></td>
                            </tr>
                        ))}
                    </tbody>
                </table>
            </div>
            {campaigns?.map((campaign) => (filteredCampaigns.length == 0 || filteredCampaigns.includes(campaign.campaign_name)) && (
                <div className="google-keywords" key={campaign.campaign_id}>
                    <div className='google-keywords-header'>
                        <div className='google-keywords-title'>{campaign.campaign_name} Campaign</div>
                        <div className='google-keywords-actions'>

                        </div>
                    </div>
                    <table className='google-keywords-table'>
                        <thead>
                            <tr>
                                <th style={{ width: '25%' }}><span>Keyword (Ad Group)</span></th>
                                <th style={{ width: '15%' }}><span>Impressions</span></th>
                                <th style={{ width: '15%' }}><span>Clicks</span></th>
                                <th style={{ width: '15%' }}><span>Conversions</span></th>
                                <th style={{ width: '15%' }}><span>Cost (CPC)</span></th>
                                <th style={{ width: '15%' }}><span>CTR</span></th>
                            </tr>
                        </thead>
                        <tbody className='small-text'>
                            {campaign?.top_keywords?.map((keyword, index) => (
                                <tr key={index}>
                                    <td style={{ width: '25%' }}><span>{keyword.keyword_text} ({keyword.ad_group_name})</span></td>
                                    <td style={{ width: '15%' }}><span>{keyword.impressions.toLocaleString()}</span></td>
                                    <td style={{ width: '15%' }}><span>{keyword.clicks.toLocaleString()}</span></td>
                                    <td style={{ width: '15%' }}><span>{keyword.conversions.toFixed(0).toLocaleString()} ({keyword.conversions > 0 ? `$${(parseFloat(keyword.cost_usd.replace(/,/g, '')) / keyword.conversions).toFixed(2)}` : '$0.00'}/conv)</span></td>
                                    <td style={{ width: '15%' }}><span>${keyword.cost_usd.toLocaleString()} (${(parseFloat(keyword.cost_usd.replace(/,/g, '')) / keyword.clicks).toFixed(2)})</span></td>
                                    <td style={{ width: '15%' }}><span>{(keyword.clicks / keyword.impressions * 100).toFixed(2)}%</span></td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                </div>
            ))}
            <div className="google-keywords">
                <div className='google-keywords-header'>
                    <div className='google-keywords-title' style={{ display: 'flex', alignItems: 'center', justifyContent: 'flex-start', gap: '5px' }}>Google Leads <span className="subtext">({leads.length})</span></div>
                </div>
                <div style={{ borderTop: '1px solid var(--border-color)' }}>
                    <div style={{ display: 'flex', backgroundColor: 'var(--card-header)', borderBottom: '1px solid var(--border-color)', padding: '0 16px' }}>
                        <div style={{ flex: '0 0 20%', padding: '8px 0', fontSize: '12px', fontWeight: 600 }}>Contact</div>
                        <div style={{ flex: '0 0 15%', padding: '8px 0', fontSize: '12px', fontWeight: 600 }}>Status</div>
                        <div style={{ flex: '0 0 15%', padding: '8px 0', fontSize: '12px', fontWeight: 600 }}>Source</div>
                        <div style={{ flex: '0 0 10%', padding: '8px 0', fontSize: '12px', fontWeight: 600 }}>Created</div>
                        <div style={{ flex: '1 1 0', padding: '8px 0', fontSize: '12px', fontWeight: 600 }}>Summary</div>
                    </div>
                    {leads.length === 0 && (
                        <div style={{ padding: '12px 16px', textAlign: 'center', fontSize: '12px' }}>No Google leads found for this period.</div>
                    )}
                    {leads.map((lead, index) => (
                        <div
                            key={index}
                            style={{ display: 'flex', padding: '0 16px', borderBottom: index === leads.length - 1 ? 'none' : '1px solid var(--border-color)', cursor: 'pointer', minHeight: 36 }}
                            onClick={() => window.open(`/intake/${lead.id}`, '_blank', 'noopener,noreferrer')}
                        >
                            <div style={{ flex: '0 0 20%', display: 'flex', alignItems: 'center', fontSize: '12px', fontWeight: 500 }}>{lead.contact_full_name || lead.contact_name || '—'}</div>
                            <div style={{ flex: '0 0 15%', display: 'flex', alignItems: 'center', fontSize: '12px', fontWeight: 500 }}>{lead.status_name || '—'}</div>
                            <div style={{ flex: '0 0 15%', display: 'flex', alignItems: 'center', fontSize: '12px', fontWeight: 500 }}>{lead.marketing_source_name || '—'}</div>
                            <div style={{ flex: '0 0 10%', display: 'flex', alignItems: 'center', fontSize: '12px', fontWeight: 500 }}>{lead.created_at ? new Date(lead.created_at).toLocaleDateString() : '—'}</div>
                            <div style={{ flex: '1 1 0', display: 'flex', alignItems: 'center', fontSize: '12px', fontWeight: 500, overflow: 'hidden' }}>
                                <span style={{ overflow: 'hidden', whiteSpace: 'nowrap', textOverflow: 'ellipsis' }}>{lead.summary || '—'}</span>
                            </div>
                        </div>
                    ))}
                </div>
            </div>
        </>
    );
};

export default GoogleAdsComponent;